// ======================================================================
// File Name       : UploadConfigFileList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import ReduxFormPaging from '../ReduxFormPaging';
import { convertStatusConfigFile } from '../../utils/index';
import { CONFIG_FILE_STATUS } from '../../constants/index';

class UploadConfigFileList extends React.Component {

  render() {
    const {
      userfrontUploadResultList,
      recordNum,
      invalid,
      onClickDownloadFile,
      handleSortState,
      getStartEndData,
      refreshData,
      startPosition,
    } = this.props;
    const thead = [
      { title: 'No', sortBy: null, width: 50 },
      { title: 'ファイル名', sortBy: 0 },
      { title: 'ステータス', sortBy: 1 },
      { title: '開始日時', sortBy: 2 },
      { title: '完了時間', sortBy: 3 },
      { title: '処理結果', sortBy: null, width: 130 },
    ];
    const userfrontUploadResultData = userfrontUploadResultList &&
    userfrontUploadResultList.map((userfrontUploadResult, index) => {
      return (
        <tr key={index}>
          <td>{startPosition + index + 1}</td>
          <td>{userfrontUploadResult.userfrontUploadFileName}</td>
          <td>{convertStatusConfigFile(userfrontUploadResult.userfrontUploadResultStatus)}</td>
          <td>{userfrontUploadResult.userfrontUploadStartTime}</td>
          <td>{userfrontUploadResult.userfrontUploadEndTime}</td>
          <td>{
            userfrontUploadResult.userfrontUploadResultStatus === CONFIG_FILE_STATUS.ERROR &&
            <Button
              variant="primary"
              className="btn-96 text-center"
              onClick={() => {
                onClickDownloadFile(
                  userfrontUploadResult.resultFileUrl,
                  userfrontUploadResult.userfrontUploadFileName,
                );
              }}
              id={index}
            >
              ダウンロード
            </Button>
          }
          </td>
        </tr>
      );
    });
    return (
      <div>
        <Form.Group>
          <Col sm={12}>
            <Button
              variant="primary"
              className="float-end btn-96"
              onClick={refreshData}
            >
              更新
            </Button>
          </Col>
          <Col sm={6} className="float-start padding-top-35">
            アップロード結果一覧
          </Col>
          <Col sm={6}>
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
              className="float-end"
            />
          </Col>
        </Form.Group>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="userfrontUploadSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {userfrontUploadResultData}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default UploadConfigFileList;
